import { rootApi } from '../rootApi';

export const dealerAddressOrderTypeApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getDealerAddressOrderTypeList: builder.query({
      query: (params) => ({
        url: 'v1/dealeraddressordertype/getlist',
        method: 'POST',
        body: params
      }),
      transformResponse: (res) => res.data,
      providesTags: ['DealerAddressOrderType']
    }),
    addDealerAddressOrderType: builder.mutation({
      query: (payload) => ({
        url: 'v1/dealeraddressordertype/add',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['DealerAddressOrderType']
    }),
    updateDealerAddressOrderType: builder.mutation({
      query: ({ id, ...rest }) => ({
        url: 'v1/dealeraddressordertype/update',
        method: 'POST',
        body: { id, ...rest }
      }),
      invalidatesTags: ['DealerAddressOrderType']
    }),
    deleteDealerAddressOrderType: builder.mutation({
      // Birleşik onay akışı için delete komutuna dealerAddressBrandId (anchor) eklendi.
      // Geriye dönük uyumluluk: hem sayısal id hem { id, dealerAddressBrandId } kabul edilir.
      query: (arg) => {
        const { id, dealerAddressBrandId } = typeof arg === 'object' && arg !== null ? arg : { id: arg };
        return {
          url: 'v1/dealeraddressordertype/delete',
          method: 'DELETE',
          body: { id, dealerAddressBrandId }
        };
      },
      invalidatesTags: ['DealerAddressOrderType', 'DealerRegistration']
    }),
    getDealerAddressOrderTypeById: builder.query({
      query: (id) => ({
        url: `v1/dealeraddressordertype/getbyid`,
        method: 'GET',
        params: { id }
      }),
      providesTags: ['DealerAddressOrderType']
    }),
    getDealerAddressOrderTypeSapList: builder.query({
      query: () => ({
        url: 'v1/dealeraddressordertype/getsaplist',
        method: 'GET'
      }),
      transformResponse: (res) => res.data,
      providesTags: ['DealerAddressOrderType']
    })
  })
});

export const {
  useGetDealerAddressOrderTypeListQuery,
  useGetDealerAddressOrderTypeByIdQuery,
  useAddDealerAddressOrderTypeMutation,
  useUpdateDealerAddressOrderTypeMutation,
  useDeleteDealerAddressOrderTypeMutation,
  useGetDealerAddressOrderTypeSapListQuery
} = dealerAddressOrderTypeApi;
